// src/stores/car.js
import { defineStore } from "pinia";
import { httpRequest } from "@/services/api";
import { showAlert } from "@/composables/useAlert";

export const useServicesStore = defineStore("service", {
  state: () => ({
    services: [],
    isLoading: false,
  }),

  actions: {
    async getServiceByType(type) {
      this.isLoading = true;
      try {
        const res = await httpRequest(`/services?type=${type}&pageSize=-1`, {
          method: "GET",
        });
        this.services = res.data || [];
      } catch (error) {
        showAlert(
          error.response?.data?.message || "حدث خطأ أثناء جلب البيانات",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },
    async addServiceRequest(id, carIds) {
      this.isLoading = true;
      try {
        const res = await httpRequest(
          `/services/store?service_id=${id}&cars_ids[]=${carIds}`,
          {
            method: "POST",
          }
        );
      } catch (error) {
        showAlert(
          error.response?.data?.message || "حدث خطأ أثناء جلب البيانات",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },
  },
});
